import axios from "axios";

const getCompaniesApi =
  process.env.REACT_APP_API_URL + "/api/get-companies-list";
const createCompanyApi = process.env.REACT_APP_API_URL + "/api/create-company";
const editCompanyApi = process.env.REACT_APP_API_URL + "/api/edit-company";

/**
 * Gets the JWT token from cookies
 * 
 * @returns {string} The JWT token
 */
const getAuthToken = () => {
  // Try to get token from cookies
  const cookies = document.cookie.split(';');
  let token = null;
  
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === '_auth') {
      token = decodeURIComponent(value);
      break;
    }
  }
  
  return token;
};

/**
 * Fetches the list of companies from the API with JWT authentication
 *
 * @returns {Promise<Array>} - The list of companies
 */
const fetchCompanies = async () => {
  try {
    // Get the JWT token from cookies
    const token = getAuthToken();

    // Include the token in the request headers
    const response = await axios.get(getCompaniesApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Companies:", error);
    throw error;
  }
};

const addCompany = async (companiesData) => {
  try {
    const token = getAuthToken();

    const response = await axios.post(createCompanyApi, companiesData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding Company:", error);
    throw error;
  }
};

const editCompany = async (companyData) => {
  try {
    const token = getAuthToken();

    const response = await axios.post(editCompanyApi, companyData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error editing Company:", error);
    throw error;
  }
};

export { fetchCompanies, addCompany, editCompany };
